module.exports = __webpack_public_path__ + "img/g9.013811bc.jpg";